export const WINNING_HANDS = {
  WinPlayerA: 'WinPlayerA',
  WinPlayerB: 'WinPlayerB',
  Push: 'Push',
  Tie: 'Tie',
} as const;
